import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { SpecificBodyInfo } from './specificBodyInfo';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import i18n from 'i18next';
import { PanelGroup } from './panelGroup';
import { GamePurchasePane } from '../../../components/GamePurchasePane/gamePurchasePane';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { Link } from 'react-router-dom';
import { Cartridge } from '../../../components/GamesList/cartridge';
import { Cartridge as ECartridge, HashupCartridge } from '../../../lib/HashupCartridge/hashupCartridge';
import { IGame } from '../../../providers/Games/useGames';
import { trimAddress } from '../../../utils/parser';
import { OpenPackage } from 'src/components/OpenPackage/openPackage';

export const RightPanel = ({
	developer,
	totalSupply,
	gamers,
	transfers,
	releaseDate,
	title,
	symbol,
	type,
	thumbsUp,
	thumbsDown,
	url,
	id,
	idOwned,
	gamePaper,
	logo,
	newsletter,
	gameData,
}: {
	developer: string;
	totalSupply: string;
	gamers: string;
	transfers: string;
	releaseDate: any;
	title: string;
	symbol: string;
	type: string;
	thumbsUp: string;
	thumbsDown: string;
	url: string;
	id: string;
	idOwned: boolean;
	gamePaper: string;
	logo: string;
	newsletter: {
		handleCheckbox: (event: any) => void;
		isCheckedForNewsletter: boolean;
		handleCheckForNewsletter: any;
	};
	gameData: IGame;
}) => {
	const { t } = useTranslation();
	const { backgroundColor, callToActionColor } = useGameColorsProvider();

	return (
		<Flex
			direction="column"
			justifyContent="flex-end"
		>
			{gameData.media.coverImageUrl && (
				<Box
					width="100%"
					height="280px"
					position="relative"
					overflow="visible"
				>
					<Box
						position="absolute"
						top="-64px"
						left="0"
						width="100%"
						height="384px"
						clipPath="polygon(0 0, 100% 0, 100% calc(100% - 40px), 0% calc(100% - 40px))"
					>
						<HashupCartridge
							cartridge={ECartridge[gameData.color.toUpperCase() as any] as unknown as ECartridge}
							cartridgeCoverUri={gameData.media.coverImageUrl}
						/>
					</Box>
				</Box>
			)}
			<Flex
				flexDirection="column"
				gridGap={{ base: '16px', hashup: '24px' }}
				justifyContent="flex-end"
			>
				<GamePurchasePane
					iconUrl={logo}
					url={url}
					id={id}
					idOwned={idOwned}
					gamePaper={gamePaper}
					gameData={gameData}
				/>
				{gameData.platforms.includes('software-key') && <OpenPackage address={id} />}
				<Flex
					gridGap="16px"
					flexDirection={{ base: 'column', md: 'row', hashup: 'column' }}
					alignItems="flex-start"
					zIndex={{ base: 5, hashup: 1 }}
				>
					<PanelGroup
						padding={{ base: '16px', hashup: '36px' }}
						isExpandable
					>
						<Flex
							gridGap={{ base: '8px', hashup: '22px' }}
							flexDirection="column"
						>
							<SpecificBodyInfo
								text={`${t('gameOverview.developer').toString()}:`}
								value={
									<Link to={`/user/${developer}`}>
										<Text color={callToActionColor}>{trimAddress(developer)}</Text>
									</Link>
								}
							/>
							<SpecificBodyInfo
								text={`${t('gameOverview.totalSupply').toString()}:`}
								value={totalSupply}
							/>
							<SpecificBodyInfo
								text={`${t('gameOverview.cartridge').toString()}:`}
								value={
									<Cartridge
										type={type.toUpperCase()}
										padding="3px 5px"
										marginLeft="2px"
										symbol={symbol}
									/>
								}
							/>
							<SpecificBodyInfo
								text={`${t('gameOverview.releaseDate').toString()}:`}
								value={moment(releaseDate).locale(i18n.language).fromNow()}
							/>
						</Flex>
					</PanelGroup>
				</Flex>
			</Flex>
		</Flex>
	);
};
